import { createContext, useState, useContext, useMemo, useCallback } from 'react';
// @ts-expect-error Untyped module
import makeDateRangeByType from 'reporting-data/lib/makeDateRangeByType';
// @ts-expect-error Untyped module
import getDefaultFrequency from 'reporting-ui-components/lib/getDefaultFrequency';
import { getValidatedMetricsToDisplay } from '../utils/reportingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_CHECKED_SOURCES = ['direct', 'email', 'offline', 'organic', 'social', 'paid', 'referrals', 'paid-social', 'other'];
const ReportingFiltersContext = /*#__PURE__*/createContext(undefined);
const ReportingFiltersProvider = ({
  children,
  allMetricsData,
  defaultMetricsToDisplay,
  defaultMetric
}) => {
  const [dateRange, setDateRange] = useState(makeDateRangeByType());
  const [frequency, setFrequency] = useState(getDefaultFrequency(dateRange));
  const [metric, setMetric] = useState(defaultMetric);
  const [metricsToDisplay, setMetricsToDisplay] = useState(getValidatedMetricsToDisplay(defaultMetricsToDisplay, allMetricsData));
  const [source, setSource] = useState('');
  const [d1, setD1] = useState('');
  const [checkedSources, setCheckedSources] = useState(DEFAULT_CHECKED_SOURCES);
  const processedFrequency = useMemo(() => {
    return frequency || getDefaultFrequency(dateRange);
  }, [dateRange, frequency]);
  const processedDateRange = useMemo(() => {
    return makeDateRangeByType({
      endDate: dateRange.endDate,
      rangeType: dateRange.rangeType,
      rollingDays: dateRange.rollingDays,
      startDate: dateRange.startDate
    });
  }, [dateRange]);
  const handleDateRangeChange = useCallback(updatedDateRange => {
    setDateRange(updatedDateRange);
    setFrequency(getDefaultFrequency(updatedDateRange));
  }, []);
  const handleSourceDrilldown = useCallback(({
    key
  }) => {
    if (!key) {
      setD1('');
      setSource('');
    } else if (!source) {
      setSource(key);
    } else if (d1 && source === key) {
      setD1('');
      setSource(source);
    } else {
      setD1(key);
    }
  }, [source, setSource, setD1, d1]);
  const value = useMemo(() => ({
    dateRange: processedDateRange,
    frequency: processedFrequency,
    metric,
    metricsToDisplay,
    setMetricsToDisplay,
    allMetricsData,
    checkedSources,
    d1,
    setCheckedSources,
    setDateRange,
    setFrequency,
    setMetric,
    source,
    handleSourceDrilldown,
    handleDateRangeChange
  }), [processedDateRange, processedFrequency, metric, metricsToDisplay, setMetricsToDisplay, allMetricsData, checkedSources, d1, setCheckedSources, source, setDateRange, setFrequency, setMetric, handleSourceDrilldown, handleDateRangeChange]);
  return /*#__PURE__*/_jsx(ReportingFiltersContext.Provider, {
    value: value,
    children: children
  });
};
export default ReportingFiltersProvider;
export function useReportingFiltersProvider() {
  const context = useContext(ReportingFiltersContext);
  if (context === undefined) {
    throw new Error('useReportingFiltersProvider must be used within a ReportingFiltersProvider');
  }
  return context;
}